import { composeIO } from 'react-compose-io'
import { adicionarChamadoFormIO } from './AdicionarChamadoForm.IO'
import AdicionarChamadoFormView from './AdicionarChamadoForm.View'

export const AdicionarChamadoForm = composeIO(AdicionarChamadoFormView, adicionarChamadoFormIO)
